import React, { useState, useEffect } from 'react';
import { getPhoto } from '../../storageService';
import { User2 } from 'lucide-react';

const ProviderImage = ({ photoPath, alt, className }) => {
    const [url, setUrl] = useState(null);

    useEffect(() => {
        let isMounted = true;
        if (photoPath) {
            getPhoto(photoPath).then(photoUrl => {
                if (isMounted && photoUrl) {
                    setUrl(photoUrl);
                }
            }).catch(e => {
                console.error("Error loading photo", e);
            });
        }
        return () => { isMounted = false; };
    }, [photoPath]);

    if (!url) {
        return <img src="" alt={alt} className={className} />;
    }

    return (
        <img
            src={url}
            alt={alt}
            className={className}
        />
    );
};

export default ProviderImage;
